import { createVuetify } from "vuetify"
import "@mdi/font/css/materialdesignicons.css"
import "vuetify/styles"

const pwaTheme = {
  dark: false,
  colors: {
    error: "#FF5252"
  }
}

export default createVuetify({
  theme: {
    defaultTheme: "pwaTheme",
    themes: {
      pwaTheme
    }
  },
  display: {
    mobileBreakpoint: "sm",
    thresholds: {
      xs: 600,
      sm: 1100,
      md: 1280,
      lg: 1600
    }
  }
})
